import { createApp } from 'vue'

import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import { router } from '@/router';
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import '@surely-vue/table/dist/index.less';
import STable from '@surely-vue/table';
import './assets/style/index.css'
const app = createApp(App)
app.use(STable);
app.use(Antd);
app.use(router);
app.component("QuillEditor", QuillEditor);
app.config.errorHandler = (err, vm, info) => {
    // 处理错误，例如记录到日志服务或控制台
    console.error('Caught an error:', err, info);
};

router.isReady().then(() => app.mount('#app'))
